import { hotel_types, hotel_categories, get_hotel_category } from './hotel_types'
import { categories, get_categories } from './categories'
import { cots_extrabeds, get_cots_extrabeds } from './cots_extrabeds'
import { languages, get_languages } from './languages'
import { review_score_values } from './review_score_values'
import { extra_charge, get_extra_charge } from './extra_charge'
import { how_to_collect, key_location, get_key_collection } from './key_collection'
import { mealplan, get_mealplan } from './mealplan'
import { beds, get_beds } from './beds'
import { policies, get_policies } from './policies'
import { room_types, get_room_types } from './room_types'
import { amenities_flags, get_amenities_flags } from './amenities_flags'
import { amenities_property, get_amenities_property } from './amenities_property'
import { amenities_rooms, get_amenities_rooms } from './amenities_rooms'
import { amenities_rates, get_amenities_rates } from './amenities_rates'
import { fees, get_fees } from './fees'

// site resources
export {
  hotel_types,
  hotel_categories,
  categories,
  cots_extrabeds,
  languages,
  review_score_values,
  extra_charge,
  how_to_collect,
  key_location,
  mealplan,
  beds,
  policies,
  room_types,
  amenities_flags,
  amenities_property,
  amenities_rooms,
  amenities_rates,
  fees,
  get_hotel_category,
  get_categories,
  get_cots_extrabeds,
  get_languages,
  get_extra_charge,
  get_key_collection,
  get_mealplan,
  get_beds,
  get_policies,
  get_room_types,
  get_amenities_flags,
  get_amenities_property,
  get_amenities_rooms,
  get_amenities_rates,
  get_fees
}